import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
export default function AboutUs() {
  const { t, i18n } = useTranslation();
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  const history = useHistory();
  const handleDivClick = (CategoryName) => {
    history.push(`/${CategoryName}`);
  };

  const [MyWidth, setMyWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setMyWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    // Cleanup listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        justifyContent: "center",
        alignItems: "center",
        paddingTop: 50,
        flexDirection: "column",
      }}
    >
      <a style={{ fontWeight: "500", fontSize: 25 }}>
        {t("navigation.Aboutus")}
      </a>
      <div
        style={{
          display: "flex",
          width: "100%",
          justifyContent: "space-between",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: MyWidth <= 1024 ? "100%" : "60%",
            paddingLeft: MyWidth <= 1024 ? "2%" : 0,
            paddingRight: MyWidth <= 1024 ? "2%" : 0,

            direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
          }}
        >
          <a style={{ fontWeight: "400", fontSize: 22 }}>
            {t("profile.OurStory")}
          </a>
          <a style={{ fontSize: 14, paddingTop: 10 }}>
            {t("longTexts.OurStoryDisc")}
          </a>

          <a style={{ fontWeight: "400", fontSize: 22, paddingTop: 20 }}>
            {t("profile.OurMissionValues")}
          </a>
          <a style={{ fontSize: 14, paddingTop: 10 }}>
            {t("longTexts.QualityFirst")}
          </a>
          <a style={{ fontSize: 14 }}>{t("longTexts.CrueltyFree")}</a>
          <a style={{ fontSize: 14 }}>{t("longTexts.Inclusivity")}</a>
          <a style={{ fontSize: 14 }}>{t("longTexts.Sustainability")}</a>
          <a style={{ fontWeight: "400", fontSize: 22, paddingTop: 20 }}>
            {t("profile.WhyChooseUs")}
          </a>
          <a style={{ fontSize: 14, paddingTop: 10 }}>
            {t("longTexts.AffordableLuxury")}
          </a>
          <a style={{ fontSize: 14 }}>{t("longTexts.TrendDrivenTimeless")}</a>
          <a style={{ fontSize: 14 }}>{t("longTexts.FastReliableShipping")}</a>
          <a style={{ fontWeight: "400", fontSize: 22, paddingTop: 20 }}>
            {t("profile.ThankYou")}
          </a>
          <a style={{ fontSize: 14, paddingTop: 10 }}>
            {t("longTexts.Thankyouforsupporting")}
          </a>
        </div>
        {MyWidth <= 1024 ? (
          <></>
        ) : (
          <div
            style={{
              width: "30%",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                display: "flex",
                border: "2px solid #f4f4f5",
                width: "100%",
                height: 160,
                justifyContent: "center",
                flexDirection: "column",
                paddingLeft: "10%",

                paddingRight: i18n.resolvedLanguage === "en" ? "" : "10%",
                direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
              }}
            >
              <a style={{ fontSize: 20, fontWeight: "500", paddingBottom: 10 }}>
                {t("sentence.Contacts")}
              </a>
              <a style={{ fontSize: 14 }}>{t("profile.WEAREALWAYSINTOUCH")}</a>
              <a style={{ fontSize: 14 }}>
                {t("sentence.Youcan")}{" "}
                <a
                  style={{
                    color: "#6b21a8",
                    textDecoration: "underline",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    handleDivClick("feedback");
                  }}
                >
                  {t("sentence.emailus")}
                </a>{" "}
                {t("sentence.callus")}
              </a>

              <a
                style={{
                  fontSize: 14,
                }}
              >
                {i18n.resolvedLanguage === "en" ? (
                  <>+972 52-747-7128</>
                ) : (
                  <>52-747-7128 972+</>
                )}
              </a>
            </div>
          </div>
        )}
      </div>

      {MyWidth <= 1024 ? (
        <div
          style={{
            width: MyWidth <= 1024 ? "100%" : "30%",
            display: "flex",
            justifyContent: "center",
            paddingTop: MyWidth <= 1024 ? 40 : 0,
          }}
        >
          <div
            style={{
              display: "flex",
              border: "2px solid #f4f4f5",
              width: "100%",
              height: 160,
              justifyContent: "center",
              flexDirection: "column",
              paddingLeft: "10%",

              paddingRight: i18n.resolvedLanguage === "en" ? "" : "10%",
              direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
            }}
          >
            <a style={{ fontSize: 20, fontWeight: "500", paddingBottom: 10 }}>
              {t("sentence.Contacts")}
            </a>
            <a style={{ fontSize: 14 }}>{t("profile.WEAREALWAYSINTOUCH")}</a>
            <a style={{ fontSize: 14 }}>
              {t("sentence.Youcan")}{" "}
              <a
                style={{
                  color: "#6b21a8",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
                onClick={() => {
                  handleDivClick("feedback");
                }}
              >
                {t("sentence.emailus")}
              </a>{" "}
              {t("sentence.callus")}
            </a>

            <a
              style={{
                fontSize: 14,
              }}
            >
              {i18n.resolvedLanguage === "en" ? (
                <>+972 52-747-7128</>
              ) : (
                <>52-747-7128 972+</>
              )}
            </a>
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
